import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getRequestBody = (data: any) => {
  return {
    id: data?.id,
    group: data?.group,
    category: data?.category,
    packageName: data?.packageName,
    fileType: data?.fileType ?? 0
  }
}

const deleteRoutingPackage = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPackageDelete),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getRequestBody(data),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { deleteRoutingPackage }
